import { useParams } from "react-router-dom";
import { useState } from "react";
import {Tab, Tabs } from "@mui/material";

//Common styles
import {
  TabsContainer,
  WorkspaceContainer,
} from "../../styles/commonStyles";

//Components
import SosAlertMetaShow from "./SosAlertMetashow";

const SosAlertShow = () => {
  const { refernceModelName, id } = useParams();
  const [activeTab, setActiveTab] = useState(0);
  console.log("reference model: ", refernceModelName);

  if (!id) return null;

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <WorkspaceContainer>
      <TabsContainer>
        <Tabs
          value={activeTab}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label="Details" />
        </Tabs>
      </TabsContainer>

      <br />

      <>
        {activeTab === 0 && (
          <SosAlertMetaShow id={id}  />
        )}
      </>
    </WorkspaceContainer>
  );
};

export default SosAlertShow;
